import { render, staticRenderFns } from "./FormVendorDialog.vue?vue&type=template&id=7fa08e1f"
import script from "./FormVendorDialog.vue?vue&type=script&lang=ts"
export * from "./FormVendorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports